/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryItemDtoPage } from '../../models/inventory-item-dto-page';

export interface ListInventoryItems$Params {
  query?: string;
  excludeIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'code' | '-code' | 'name' | '-name' | 'brand' | '-brand' | 'description' | '-description' | 'unitOfMeasure' | '-unitOfMeasure' | 'initialStock' | '-initialStock' | 'currentStock' | '-currentStock' | 'minimumStock' | '-minimumStock' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listInventoryItems(http: HttpClient, rootUrl: string, params?: ListInventoryItems$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryItemDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listInventoryItems.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryItemDtoPage>;
    })
  );
}

listInventoryItems.PATH = '/v0/inventoryItems';
